"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicVideoCardsService = void 0;
var tslib_1 = require("tslib");
var queries_1 = require("./queries");
var mappers_1 = require("./mappers");
var guid_1 = require("../../utils/guid");
var base_public_service_1 = require("../base-public-service");
var PublicVideoCardsService = /** @class */ (function (_super) {
    tslib_1.__extends(PublicVideoCardsService, _super);
    function PublicVideoCardsService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PublicVideoCardsService.prototype.getList = function (videoId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp, cards;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_VIDEO_CARD_QUERY, {
                            videoId: videoId,
                        })];
                    case 1:
                        resp = _a.sent();
                        cards = resp.video.cards.entities.map(function (card) {
                            return (0, mappers_1.mapGqlCardToOldCard)(card, { clientId: (0, guid_1.guid)() });
                        });
                        return [2 /*return*/, { data: cards }];
                }
            });
        });
    };
    return PublicVideoCardsService;
}(base_public_service_1.BasePublicService));
exports.PublicVideoCardsService = PublicVideoCardsService;
//# sourceMappingURL=video-cards.js.map